/* istanbul ignore file: just rendering a button */
import { Classes } from '@blueprintjs/core';
import * as React from 'react';

import { copy } from 'src/ui/templates/copy';
import duoLogo from 'src/ui/templates/images/duo-logo.svg';
import { doDuoRedirect } from 'src/ui/utils/window';

/**
 * This uses just a plain button as we use an image to display the actual
 * button. We don't want this to be styled by blueprintjs.
 */
export const DuoLink: React.VFC = () => {
  return (
    <button
      type="button"
      onClick={doDuoRedirect}
      className={`${Classes.BUTTON} oauth`}
    >
      <img src={duoLogo} alt={copy.duo.label} />
    </button>
  );
};
